import React, { Component } from "react";
export default class Recipe extends Component {
  componentWillUnmount() {
      this.props.resetStore();
  }

  componentWillMount() {
      if (this.props.match.params.id) {
          this.props.getDiagnosticPlan(this.props.match.params.id);
      }      
  }
  
  render(){    
    const handlePrint = () => {      
      window.print();      
      window.close();
    };
    
    const fechaFormateada = new Date().toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric'}).replace(/\//g, '-');
    
    const { receta } = this.props;
    const signature = receta ? receta.doctor ? receta.doctor.signature: null : null;

    return(
      <React.Fragment>        
        <div
            className="dont-print"
            style={{
                display: "flex",
                justifyContent: "right",
                margin: "20px 20px 20px 0px",
            }}
        >
            <button
                className="btn btn-primary ml-3 mr-3"
                style={{
                    maxWidth: "100px",
                }}
                //onClick={() => print()}
                onClick={handlePrint}
            >
                IMPRIMIR
            </button>
        </div>
        <div          
          style={{
              position: "relative",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              color: "black"
          }}
        >
          <div            
            style={{
                //width: "800px",
                width: "500px",
                //height: "100%",
                height: "820px",
                backgroundColor: "white",
                paddingInline: '24px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between'
            }}
          >
          {/*
          <div
            style={{ display: 'flex', justifyContent: 'flex-end'}}
          >            
            <span
              style={{
                background: 'gray',
                fontWeight: 'bold',
                color: 'white',
                padding: '12px',
                borderBottomLeftRadius: '12px'
              }}
            >{this.props.match.params.patient && this.props.match.params.patient}</span>
            
          </div>
          */}
          <div>
            <div className="d-flex justify-center mt-5 mb-2">
                  <img
                      style={{ margin: '0 auto' }}
                      src={require("../../../../../assets/img/logo_prolaser_gris.png")}
                      alt="Prolaser_logo"
                      className="logo-transcription"
                  />
            </div>  

            {/*this.props.receta && this.props.receta.dx && this.props.receta.dx.length > 0 &&
                  <React.Fragment>
                    <div style={{color: 'black'}}>
                      <p style={{ fontWeight: 700, marginBottom: '5px'}}>Diagnóstico</p>
                      <ul>
                          {this.props.receta.dx.map((diagnostico, key) => (
                              <li key={key}>
                                  <span>{diagnostico.nombre.label}</span>
                              </li>
                          ))}
                      </ul>
                    </div>
                      <br />
                  </React.Fragment>
            */}         

            <div 
              className="mt-2 mb-2"
              style={{ borderTop: 'solid 3px red', width: '90%', margin: '0 auto' }}
            ></div>

            <div className="d-flex flex-row align-bottom mt-3">
              <strong style={{ textTransform: 'capitalize' }}>Paciente:</strong>
              <div className="d-flex w-100" style={{ borderBottom: 'solid 1px black', textTransform: 'capitalize' }}>
                &nbsp;&nbsp;{this.props.match.params.patient && this.props.match.params.patient}
              </div>
            </div>
            <div className="d-flex flex-row align-bottom">
              <strong style={{ textTransform: 'capitalize' }}>Fecha:</strong>
              <div className="d-flex w-100" style={{ borderBottom: 'solid 1px black', textTransform: 'capitalize'}}>
                &nbsp;&nbsp; { fechaFormateada }
              </div>
            </div>
            
            <p>
              <strong style={{ fontSize: 24, textTransform: 'capitalize', fontStyle: 'italic' }}>Rp.</strong>
            </p>
              {this.props.receta && this.props.receta.txn && this.props.receta.txn.length == 1 && 
              <React.Fragment>
                      {/*<p style={{ fontWeight: 700, marginBottom: '5px'}}>RECETA</p>*/}
                      <React.Fragment>
                          {this.props.receta.txn[0].td_dp.map((treatment, key) => (
                              <div key={key} className='mt-1' style={{color: 'black', fontSize: '10px'}}>                            
                                  <p style={{ marginBottom: 0, textDecoration: "underline" }}>Medicamento</p>
                                  <p style={{ marginTop: 0, marginBottom: 0 }}>
                                    <strong>{treatment.commercial_name}</strong> {treatment.quantity} {treatment.presentation} (<span>Principio activo: <strong>{treatment.active_principle}</strong></span>)
                                    
                                    {treatment.application && <span className="ml-2">Aplicación: <strong>{treatment.application}</strong></span>}
                                  </p>
                                  
                                  <p style={{ marginTop: 0 }}>Administrar {treatment.dose} cada {treatment.frecuency} por {treatment.time_duration}</p>
                              </div>
                          ))}                                                   
                      </React.Fragment>                            
                  </React.Fragment>
              }          
              {/*<div className='mt-2'>{this.props.receta ? this.props.receta.notes : null}</div>*/}
            </div>            
            <div>              
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  fontSize: '12px'
                }}
              >
                {signature &&
                  <div
                    style={{
                      display: 'flex',                
                      justifyContent: 'right',
                      alignItems: 'center',
                      fontSize: '12px',
                      filter: 'contrast(1.05) brightness(1.02)'
                    }}
                  >
                    {
                    <img 
                        src={typeof signature === 'string' ? signature : URL.createObjectURL(signature)} 
                        alt="Firma" 
                        style={{maxWidth: '200px', maxHeight: '100px', objectFit: 'contain'}}
                    />
                    }
                  </div>
                }
                <span style={{ textTransform: 'capitalize' }}>5a. Calle 14-35, zona 3, Edificio Las Tapias, Oficina 107</span>
                <span style={{ textTransform: 'lowercase' }}>Tels. 7736-8712 y 7767-6590 / e-mail: prolaserguatemala@gmail.com</span>
                <span style={{ textTransform: 'capitalize' }}>WhatsApp 4220-3735</span>
                <span style={{ textTransform: 'capitalize' }}>www.prolaserguatemala.com.gt</span>
              </div>
              <div className="d-flex justify-center pb-2">
                <span
                  style={{
                    margin: '0 auto',
                    marginTop: 8,
                    borderTop: 'solid 2px black',
                    fontWeight: 'bold'
                  }}
                >FAVOR NO CAMBIAR EL MEDICAMENTO DE LA RECETA</span>
              </div>
            </div>            
          </div>
        </div>
      </React.Fragment>
    );
  }
}